import { Breadcrumbs } from '@material-ui/core'
import React, { useContext, useEffect } from 'react'
import { Link, useLocation } from 'react-router-dom'
import RoutesContext from '../../context/routeContext'
import ROUTES from '../../routers/routes'
import { makeStyles } from '@material-ui/core/styles'

import './CurrentNav.scss'

const useStyles = makeStyles((theme) => ({
  textFirst: {
    fontSize: '14px',
  },
}))
const CurrentNav = () => {
  const classes = useStyles()
  const { currentRoute, setCurrentRoute } = useContext(RoutesContext)
  const { pathname } = useLocation()

  useEffect(() => {
    const path = pathname.split('/')
    path.shift()
    setCurrentRoute(path)
  }, [setCurrentRoute, pathname])

  // const getPathname = (route) => {
  //   let obj
  //   const ruta = route.toUpperCase()
  //   if (ruta !== '') {
  //     obj = ROUTES[ruta]
  //   } else {
  //     obj = '/'
  //     setCurrentRoute('')
  //   }

  //   if (obj) {
  //     return obj.pathname
  //   } else {
  //     return obj
  //   }
  // }

  /* 
    const renderBreadcrumbs = () => {
    const breadcrumbs = [];
    currentRoute.forEach((route, i) => {
      if (i !== 0) {
        let pathStr = '/'
        currentRoute.slice(0,(i+1)).forEach(element => {
          pathStr += `${element}/`
        });
        breadcrumbs.push(
          <Link key={Math.random()} color="inherit" to={pathStr}>
            {route}
          </Link>
        )
      }
    })
    return breadcrumbs
  }
  */
  return (
    <Breadcrumbs
      // aria-label="breadcrumb-navegation"
      className={classes.textFirst + ' nav'}
      separator="/"
    >
      {currentRoute &&
      currentRoute.length &&
      ROUTES &&
      !currentRoute?.includes('operaciones') ? (
        <Link
          key={Math.random()}
          // color="inherit"
          // to={'/'}
          style={{ PointerEvent: 'none' }}
        >
          Home
        </Link>
      ) : null}
      {currentRoute.length > 0 ? (
        currentRoute.map((route) => (
          <Link
            key={Math.random()}
            // color="inherit"
            // to={() => getPathname(route)}
            style={{ PointerEvent: 'none' }}
          >
            {route === 'pga' || route === 'pgi'
              ? route.toUpperCase()
              : `${route.charAt(0).toUpperCase()}${route.slice(1)}`}
          </Link>
        ))
      ) : (
        <Link
          key={Math.random()}
          // color="inherit" to={'/'}
          style={{ PointerEvent: 'none' }}
        >
          Home
        </Link>
      )}
    </Breadcrumbs>
  )
}

export default CurrentNav
